/**
 * Created by DynamicDog on 2017-02-20.
 */
import {Component} from '@angular/core';
import {EtikettService} from "../services/etikett.service";
@Component({
    selector: 'regler-panel',
    template: `
            <div id="regler-panel">
            <h1>{{'Tävlingsregler'}}</h1>
            <p>Lorem ipsum dolor sit amet, facilis moderatius no mel, eos in feugait pertinacia. Id
impedit expetenda sed. Inani iisque docendi qui ex, laoreet verterem est eu. Tale congue
intellegebat vel cu, vim no doming officiis vituperatoribus. Quot facer eum et. </p>
<p>Choro laboramus incorrupte ea mea. Nisl lorem disputationi ut sit, no veri postulant pri,
quo et ferri admodum docendi. Nibh dolore alienum pri ut. Cu vix audire lucilius, ex
timeam accommodare pro.</p>
</div>
        `,
})

export class ReglerPanelComponent {
    constructor(private etikettService:EtikettService) {

    }

    private onUpload() {
    }
}


// WEBPACK FOOTER //
// ./app/upload/reglerpanel.component.ts